import  { AxiosResponse, AxiosError, AxiosResponseHeaders } from "axios"
import axios  from "./index"
import { AuthHeaders, MedicalInformation } from "../stores/store_types"

const callMedicalInformationsAPI = (headers: AuthHeaders, parameter: { targetMonth: Date }, successCallback: (headers: AxiosResponseHeaders, results: Array<MedicalInformation>) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/medical_informations",
    {
      headers: headers,
      params: {
        target_month: parameter.targetMonth.toString()
      }
    }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
const callLatestMedicalInformationsAPI = (headers: AuthHeaders, successCallback: (headers: AxiosResponseHeaders, results: Array<MedicalInformation>) => void, failureCallback: () => void) => {
  axios.get(
    "/api/v1/medical_informations/latest",
    { headers: headers }
  ).then((response: AxiosResponse) => {
    successCallback(response.headers, response.data)
  }).catch((error: AxiosError) => {
    console.error(error)
    failureCallback()
  })
}
export { callMedicalInformationsAPI, callLatestMedicalInformationsAPI }
